<template>
  <section class="start-screen">
    <div
      class="start-screen-option start-screen-option--lookup"
      @click="$router.push({ name: 'Lookup' })"
    >
      <div class="start-screen-option__content">
        <div class="start-screen-option__text">
          <h2 class="start-screen-option__heading">Is my enrollment platform supported?</h2>
          <button
            class="start-screen-option__button"
            id="lookup-button"
          >
            Platform Lookup
          </button>
        </div>
      </div>
    </div>
    <div
      class="start-screen-option start-screen-option--compare"
      @click="$router.push({ name: 'Compare' })"
    >
      <div class="start-screen-option__content">
        <div class="start-screen-option__text">
          <h2 class="start-screen-option__heading">Compare multiple platforms side-by-side</h2>
          <button
            class="start-screen-option__button"
            id="compare-button"
          >
            Compare Platforms
          </button>
        </div>
      </div>
    </div>
    <div
      class="start-screen-option start-screen-option--wizard"
      @click="$router.push({ name: 'Wizard' })"
    >
      <div class="start-screen-option__content">
        <div class="start-screen-option__text">
          <h2 class="start-screen-option__heading">Help me choose the best platform</h2>
          <button
            class="start-screen-option__button"
            id="wizard-button"
          >
            Help Me Choose
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import UnumButton from '@/components/ui/Button'
// import { db } from '@/appConfig/appConfig'
import { mapActions } from 'vuex'

import sessionEvent from '@/util/sessionEvent'

export default {
  components: {
    UnumButton
  },
  data () {
    return {

    }
  },
  // async created () {
  //   this.setPlatforms(await this.platforms)

  //   const productsCache = db.ref('blueprints/products').once('value')
  //     .then(function (productsBluePrint) {
  //       let productsWithKey = {}
  //       Object.entries(productsBluePrint.val())
  //         .forEach(productEntryKey => {
  //           productsWithKey[productEntryKey[0]] = productEntryKey[1]
  //         })
  //       return productsWithKey
  //     })
  //   this.$store.dispatch('platforms/setProductsCache', await productsCache)
  // },
  mounted () {
    this.clearWizard()
    this.clearCurrentPlatform()
    this.clearChosenPlatforms()
  },
  // firebase: {
  //   platforms: {
  //     source: db.ref('platforms').orderByChild('published').equalTo(true),
  //     readyCallback (thing) {
  //       console.log('[Lookup.vue] - LOADED PLATFORMS')
  //     }
  //   }
  // },
  methods: {
    ...mapActions('platforms', [
      'setPlatforms',
      'clearCurrentPlatform',
      'clearChosenPlatforms'
    ]),
    ...mapActions('wizard', [
      'clearWizard'
    ]),
    wizardStartButtonClickEvent () {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_start_screen_wizard_button')
      this.$router.push({name: 'Wizard'})
    },
    compareStartButtonClickEvent () {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_start_screen_compare_button')
      this.$router.push({name: 'Compare'})
    },
    lookupStartButtonClickEvent () {
      const sessionKey = this.$storage.get('session_key')
      sessionEvent(sessionKey, 'clicked_start_screen_lookup_button')
      this.$router.push({name: 'Lookup'})
    }
  }
}
</script>

<style lang="scss" scoped>
.start-screen {
  overflow: auto;
  bottom: 0;
  display: flex;
  flex-direction: column;
  height: calc(100% - 8rem);
  @include bp($medium) {
    height: calc(100% - 5rem);
  }
  @include bp($large) {
    flex-direction: row;
  }
}
.start-screen-option {
  cursor: pointer;
  position: relative;
  display: flex;
  flex: 1;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  @include bp($large) {
    background-color: #CCC;
    background-size: auto 100%;
  }
  &__content {
    display: flex;
    align-items: center;
    flex: 1;
    width: 100%;
    padding: rem(20px);
    background-color: #104566;
    @include bp($small) {
      background-color: rgba(#104566, 0.9);
    }
    @include bp($large) {
      align-items: stretch;
      flex: 0 1 auto;
      position: absolute;
      top: 70%;
      left: 0;
      max-width: rem(320px);
      height: rem(276px);
      margin: rem(-138px) 0 0;
      padding: rem(55px) rem(20px);
      background-color: rgba($blue, 0.9);
    }
    @include bp($xlarge) {
      max-width: rem(405px);
    }
  }
  &__text {
    max-width: 205px;
    margin: 0 auto;
    @include bp($small) {
      max-width: 250px;
    }
    @include bp($large) {
      max-width: rem(235px);
    }
  }
  &__heading {
    margin: 0 0 10px;
    color: #FFF;
    font-family: $barlow-condensed;
    font-weight: 300;
    font-size: 26px;
    line-height: 1.2;
    @include bp($small) {
      font-size: 32px;
    }
    @include bp($medium) {
      margin: 0 0 rem(18px);
    }
    @include bp($large) {
      font-size: rem(30px);
    }
  }
  &__button {
    cursor: pointer;
    display: block;
    width: 100%;
    padding: rem(10px) 0;
    color: $steelblue3;
    text-transform: uppercase;
    font-family: $barlow;
    font-weight: 600;
    font-size: 16px;
    line-height: 1;
    border-radius: rem(3px);
    border: 0;
    background-color: $leaf;
    transition: background-color 0.3s;
    @include bp($small) {
      padding: rem(16px) 0;
      font-size: 19px;
    }
    @include bp($large) {
      padding: rem(10px) 0;
      font-size: rem(16px);
    }
    &:hover {
      background-color: lighten($leaf, 10);
    }
  }
  &--lookup {
    background-position: 20% 45%;
    background-size: 130% auto;
    @include bp($small) {
      background-image: url('~@/assets/images/bg-woman-laptop-2021.jpg');
    }
    @include bp($large) {
      background-position: 73% bottom;
      background-size: auto 125%;
    }
  }
  &--compare {
    background-position: 20% top;
    background-size: 120% auto;
    @include bp($small) {
      background-image: url('~@/assets/images/bg-woman-apples-2021.jpg');
    }
    @include bp($large) {
      background-position: 75% center;
      background-size: auto 102%;
    }
    .start-screen-option__content {
      background-color: #06354C;
      @include bp($small) {
        background-color: rgba(#06354C, 0.9);
      }
      @include bp($large) {
        background-color: rgba($blue, 0.9);
      }
    }
  }
  &--wizard {
    background-position: right 10%;
    @include bp($small) {
      background-image: url('~@/assets/images/bg-couple-notebooks-2021.jpg');
    }
    @include bp($large) {
      background-position: 95% center;
      background-size: auto 101%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StartScreen.vue